import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import InputBar from "../../components/ConfigAccessControl/InputBar";
import * as FeatureConfigActions from "../../store/actions/FeatureConfig";
import * as UserActions from "../../store/actions/User";
import { Heading } from "../../constants/assets/containers";
import { isMobile } from "../../utils";
import ResourceCard from "../../components/ConfigAccessControl/Item";
import { Box } from "@material-ui/core";
import Button from "sushiweb/Button"
import { PublicRounded } from "@material-ui/icons";
import Typography from '@mui/material/Typography';
import KeyRounded from '@material-ui/icons/VpnKeyRounded';
import Menu from 'sushiweb/Icons/all/Menu';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

const ACCESS_MAPPING = ["NONE", "READ", "WRITE", "DELETE", "ADMIN"];

const ConfigAccessControl = (props) => {

  React.useEffect(() => {
    props.setSideBarCollapsed(true);
  });

  const [email, setEmail] = useState('');
  const [acceptPolicies, setAcceptPolicies] = useState([]);
  const [rejectPolicies, setRejectPolicies] = useState([]);
  const [globalAcceptPolicies, setGlobalAcceptPolicies] = useState([
  ]);
  const [namespaceAcceptPolicies, setNamespaceAcceptPolicies] = useState([])
  const [configAcceptPolicies, setConfigAcceptPolicies] = useState([])
  const [globalRejectPolicies, setGlobalRejectPolicies] = useState([])
  const [namespaceRejectPolicies, setNamespaceRejectPolicies] = useState([])
  const [configRejectPolicies, setConfigRejectPolicies] = useState([])


  const handlePolicyUpdate = (id, type, policy) => {
    console.log("Inside handlePolicyUpdate: ", id, type, policy);
    if (type === 'allowed') {
      switch (policy.resource.name) {
        case "namespace":
          const updatedNamespaceAcceptPolicies = namespaceAcceptPolicies.map((card) => {
            if (card.id === id) {
              card.access = policy.access;
              card.resource = policy.resource;
            }
            return card;
          });
          setNamespaceAcceptPolicies(updatedNamespaceAcceptPolicies);
          break;
        case "config":
          const updatedConfigAcceptPolicies = configAcceptPolicies.map((card) => {
            if (card.id === id) {
              card.access = policy.access;
              card.resource = policy.resource;
            }
            return card;
          });
          setConfigAcceptPolicies(updatedConfigAcceptPolicies);
          break;
        default:
          const updatedGlobalAcceptPolicies = globalAcceptPolicies.map((card) => {
            if (card.id === id) {
              card.access = policy.access;
              card.resource = policy.resource;
            }
            return card;
          });
          setGlobalAcceptPolicies(updatedGlobalAcceptPolicies);
      }
    } else {
      switch (policy.resource.name) {
        case "namespace":
          const updatedNamespaceRejectPolicies = namespaceRejectPolicies.map((card) => {
            if (card.id === id) {
              card.access = policy.access;
              card.resource = policy.resource;
            }
            return card;
          });
          setNamespaceRejectPolicies(updatedNamespaceRejectPolicies);
          break;
        case "config":
          const updatedConfigRejectPolicies = configRejectPolicies.map((card) => {
            if (card.id === id) {
              card.access = policy.access;
              card.resource = policy.resource;
            }
            return card;
          });
          setConfigRejectPolicies(updatedConfigRejectPolicies);
          break;
        default:
          const updatedGlobalRejectPolicies = globalRejectPolicies.map((card) => {
            if (card.id === id) {
              card.access = policy.access;
              card.resource = policy.resource;
            }
            return card;
          });
          setGlobalRejectPolicies(updatedGlobalRejectPolicies);
      }
    }
  };

  const handleRemove = (id, type, resource) => {
    console.log("Inside handleRemove: ", id, type, resource);
    const index = id - 1;
    if (type === 'allowed') {
      switch (resource) {
        case "namespace":
          const filteredNamespaceAcceptPolicies = namespaceAcceptPolicies.filter((_, i) => i !== index) || [];
          setNamespaceAcceptPolicies(filteredNamespaceAcceptPolicies.map((card, index) => {
            card.id = index + 1
            return card;
          }));
          break;
        case "config":
          const filteredConfigAcceptPolicies = configAcceptPolicies.filter((_, i) => i !== index) || [];
          setConfigAcceptPolicies(filteredConfigAcceptPolicies.map((card, index) => {
            card.id = index + 1
            return card;
          }));
          break;
        default:
          const filteredGlobalAcceptPolicies = globalAcceptPolicies.filter((_, i) => i !== index) || [];
          console.log("filteredGlobalAcceptPolicies: ", filteredGlobalAcceptPolicies);
          setGlobalAcceptPolicies(filteredGlobalAcceptPolicies.map((card, index) => {
            card.id = index + 1
            return card;
          }));
      }
    } else {
      switch (resource) {
        case "namespace":
          const filteredNamespaceRejectPolicies = namespaceRejectPolicies.filter((_, i) => i !== index) || [];
          setNamespaceRejectPolicies(filteredNamespaceRejectPolicies.map((card, index) => {
            card.id = index + 1
            return card;
          }));
          break;
        case "config":
          const filteredConfigRejectPolicies = configRejectPolicies.filter((_, i) => i !== index) || [];
          setConfigRejectPolicies(filteredConfigRejectPolicies.map((card, index) => {
            card.id = index + 1
            return card;
          }));
          break;
        default:
          const filteredGlobalRejectPolicies = globalRejectPolicies.filter((_, i) => i !== index) || [];
          setGlobalRejectPolicies(filteredGlobalRejectPolicies.map((card, index) => {
            card.id = index + 1
            return card;
          }));
      }
    }
  };



  const handleSubmitPolicies = () => {
    const acceptResourcePolicies = [
      ...globalAcceptPolicies,
      ...namespaceAcceptPolicies,
      ...configAcceptPolicies].map(card => {
        console.log("card: ", card);
        return {
          access: card.access,
          resource: card.resource
        }
      });
    const rejectResourcePolicies = [
      ...globalRejectPolicies,
      ...namespaceRejectPolicies,
      ...configRejectPolicies].map(card => {
        return {
          access: card.access,
          resource: card.resource
        }
      });

    const payload = {
      user: {
        email: email,
        acceptResourcePolicies,
        rejectResourcePolicies
      }
    };
    props.upsertUser(payload).then((response) => {
      if (response.success) {
        props.setStatus({
          type: "success",
          message: response.message,
        });
        handleSearch({ email: email });
      } else {
          props.setStatus({
            type: "error",
            message: response.message,
          })
      }
    })
  };

  const handleAddGlobalCard = () => {
    const newCard = {
      id: globalAcceptPolicies.length + 1,
      access: 1, // Default access value
      resource: {
        name: "*",
        pattern: "*"
      }, // Default resource name
      handleRemove: { handleRemove },
      type: "allowed"
    };
    setGlobalAcceptPolicies([...globalAcceptPolicies, newCard]);
  }

  const handleAddGlobalRejectCard = () => {
    const newCard = {
      id: globalRejectPolicies.length + 1,
      access: 1, // Default access value
      resource: {
        name: "*",
        pattern: "*"
      }, // Default resource name
      handleRemove: { handleRemove },
      type: "reject"
    };
    setGlobalRejectPolicies([...globalRejectPolicies, newCard]);
  }

  const handleAddNamespaceCard = () => {
    const newCard = {
      id: namespaceAcceptPolicies.length + 1,
      access: 1, // Default access value
      resource: {
        name: "namespace",
        pattern: "*"
      },
      handleRemove: { handleRemove },
      type: "allowed"
    };
    setNamespaceAcceptPolicies([...namespaceAcceptPolicies, newCard]);

  }

  const handleAddNamespaceRejectCard = () => {
    const newCard = {
      id: namespaceRejectPolicies.length + 1,
      access: 1, // Default access value
      resource: {
        name: "namespace",
        pattern: "*"
      },
      handleRemove: { handleRemove },
      type: "reject"
    };
    setNamespaceRejectPolicies([...namespaceRejectPolicies, newCard]);

  }

  const handleAddConfigCard = () => {
    const newCard = {
      id: configAcceptPolicies.length + 1,
      access: 1, // Default access value
      resource: {
        name: "config",
        pattern: "*/*"
      },
      handleRemove: { handleRemove },
      type: "allowed"
    };
    setConfigAcceptPolicies([...configAcceptPolicies, newCard]);
  }

  const handleAddConfigRejectCard = () => {
    const newCard = {
      id: configRejectPolicies.length + 1,
      access: 1, // Default access value
      resource: {
        name: "config",
        pattern: "*/*"
      },
      handleRemove: { handleRemove },
      type: "reject"
    };
    setConfigRejectPolicies([...configRejectPolicies, newCard]);
  }

  const handleSearch = (data) => {
    Object.keys(data).forEach(
      (key) => (data[key] === undefined || data[key] === "") && delete data[key]
    );

    if (Object.keys(data).length > 0) {
      props.getUser(data.email).then((response) => {
        console.log("response: ", response);

        const acceptResourcePolicies = response.user?.acceptResourcePolicies || [];
        const rejectResourcePolicies = response.user?.rejectResourcePolicies || [];

        setAcceptPolicies(acceptResourcePolicies);
        setRejectPolicies(rejectResourcePolicies);
        setEmail(response.user.email);

        const namespaceAcceptPolicies = [], configAcceptPolicies = [], globalAcceptPolicies = [];

        acceptResourcePolicies.map(card => {
          if (card.resource.name == "namespace") {
            card.id = namespaceAcceptPolicies.length + 1;
            namespaceAcceptPolicies.push(card)
          }
          else if (card.resource.name == "config") {
            card.id = configAcceptPolicies.length + 1;
            configAcceptPolicies.push(card)
          }
          else {
            card.id = globalAcceptPolicies.length + 1;
            globalAcceptPolicies.push(card)
          }
        });

        setNamespaceAcceptPolicies(namespaceAcceptPolicies)
        setConfigAcceptPolicies(configAcceptPolicies)
        setGlobalAcceptPolicies(globalAcceptPolicies)

        const namespaceRejectPolicies = [], configRejectPolicies = [], globalRejectPolicies = [];
        rejectResourcePolicies.map(card => {
          if (card.resource.name == "namespace") {
            card.id = namespaceRejectPolicies.length + 1;
            namespaceRejectPolicies.push(card)
          }
          else if (card.resource.name == "config") {
            card.id = configRejectPolicies.length + 1;
            configRejectPolicies.push(card)
          }
          else {
            card.id = globalRejectPolicies.length + 1;
            globalRejectPolicies.push(card)
          }
        }
        );
        setNamespaceRejectPolicies(namespaceRejectPolicies)
        setConfigRejectPolicies(configRejectPolicies)
        setGlobalRejectPolicies(globalRejectPolicies)


      });
    }
  };






  return (
    <AccessControlContainer>
      <Box marginTop={3} alignContent={"center"} alignItems={"center"} justifyContent={"center"}>
        <InputBar handleSubmit={handleSearch} btnColor="coal" justifyContent={"center"} />
      </Box>
      {
        email && (
          <Box marginLeft={3}>
        <Heading style={{ marginBotton: '40px' }} > Allowed Resources </Heading>

        {
          (
            <>
              <Box display="flex" alignItems="center" marginTop={3}>
                <PublicRounded />
                <Typography variant="h2" component="div" marginLeft={1} fontWeight="bold" marginTop={0} >
                  Global
                </Typography>
              </Box>
              {(
                <Box style={containerStyle}>
                  {
                    globalAcceptPolicies.length > 0 && globalAcceptPolicies.map(card =>
                    (
                      <ResourceCard
                        handlePolicyUpdate={handlePolicyUpdate}
                        access={ACCESS_MAPPING[card.access]}
                        getNamespaces={props.getNamespaces}
                        getKeys={props.getKeys}
                        resource={card.resource}
                        resourceName={card.resource.name}
                        key={card.id}
                        id={card.id}
                        handleRemove={handleRemove}
                        type={"allowed"}
                      />
                    ))
                  }
                  <Box display="flex" alignItems="center" marginLeft={3} zIndex={"1"}>
                    <Fab color="black" aria-label="add" style={{ marginLeft: "0" }} onClick={handleAddGlobalCard}>
                      <AddIcon />
                    </Fab>
                  </Box>
                </Box>
              )}

            </>
          )
        }

        {
          (
            <>
              <Box display="flex" alignItems="center" marginTop={3} >
                <Menu />
                <Typography variant="h2" component="div" marginLeft={1} fontWeight="bold" marginTop={0} >
                  Namespace
                </Typography>
              </Box>
             
              <Box style={containerStyle}>
                {
                  namespaceAcceptPolicies.length > 0 && namespaceAcceptPolicies.map(card =>
                    console.log("namespace card --->", card) ||
                    (
                      <ResourceCard
                        handlePolicyUpdate={handlePolicyUpdate}
                        getNamespaces={props.getNamespaces}
                        getKeys={props.getKeys}
                        resource={card.resource}
                        resourceName={card.resource.name}
                        access={ACCESS_MAPPING[card.access]}
                        id={card.id}
                        key={card.id}
                        handleRemove={handleRemove}
                        type={"allowed"}
                        namespace={card.resource.pattern}
                      />
                    ))
                }
                <Box display="flex" alignItems="center" marginLeft={3} zIndex={"1"}>
                  <Fab color="black" aria-label="add" style={{ marginLeft: "0" }} onClick={handleAddNamespaceCard}>
                    <AddIcon />
                  </Fab>
                </Box>
              </Box>
            </>
          )
        }

        {
          (
            <>
              <Box display="flex" alignItems="center" marginTop={3}>
                <KeyRounded />
                <Typography variant="h2" component="div" marginLeft={1} fontWeight="bold" marginTop={0} >
                  Config
                </Typography>
              </Box>
              <Box style={containerStyle}>
                {
                  configAcceptPolicies.length > 0 && configAcceptPolicies.map(card =>
                  (
                    <ResourceCard
                      handlePolicyUpdate={handlePolicyUpdate}
                      access={ACCESS_MAPPING[card.access]}
                      getKeys={props.getKeys}
                      resource={card.resource}
                      getNamespaces={props.getNamespaces}
                      resourceName={card.resource.name}
                      pattern={card.resource.pattern}
                      handleRemove={handleRemove}
                      type={"allowed"}
                      key={card.id}
                      id={card.id}
                    />
                  ))
                }
                <Box display="flex" alignItems="center" marginLeft={3} zIndex={"1"}>
                  <Fab color="black" aria-label="add" style={{ marginLeft: "0" }} onClick={handleAddConfigCard}>
                    <AddIcon />
                  </Fab>
                </Box>
              </Box>
            </>
          )
        }


        <Heading style={{ marginBotton: '40px' }} >Not Allowed Resources </Heading>

        {
          (
            <>
              <Box display="flex" alignItems="center" marginTop={3}>
                <PublicRounded />
                <Typography variant="h2" component="div" marginLeft={1} fontWeight="bold" marginTop={0} >
                  Global
                </Typography>
              </Box>
              {(
                <Box style={containerStyle}>
                  {
                    globalRejectPolicies.length > 0 && globalRejectPolicies.map(card =>
                    (
                      <ResourceCard
                        handlePolicyUpdate={handlePolicyUpdate}
                        access={ACCESS_MAPPING[card.access]}
                        resource={card.resource}
                        getNamespaces={props.getNamespaces}
                        getKeys={props.getKeys}
                        resourceName={card.resource.name}
                        key={card.id}
                        id={card.id}
                        handleRemove={handleRemove}
                        type={"reject"}
                      />
                    ))
                  }
                  <Box display="flex" alignItems="center" marginLeft={3} zIndex={"1"}>
                    <Fab color="black" aria-label="add" style={{ marginLeft: "0" }} onClick={handleAddGlobalRejectCard}>
                      <AddIcon />
                    </Fab>
                  </Box>
                </Box>
              )}

            </>
          )
        }

        {
          (
            <>
              <Box display="flex" alignItems="center" marginTop={3}>
                <Menu />
                <Typography variant="h2" component="div" marginLeft={1} fontWeight="bold" marginTop={0} >
                  Namespace
                </Typography>
              </Box>
              <Box style={containerStyle}>
                {
                  namespaceRejectPolicies.length > 0 && namespaceRejectPolicies.map(card =>
                    console.log("namespace card --->", card) ||
                    (
                      <ResourceCard
                        handlePolicyUpdate={handlePolicyUpdate}
                        getNamespaces={props.getNamespaces}
                        getKeys={props.getKeys}
                        resource={card.resource}
                        resourceName={card.resource.name}
                        access={ACCESS_MAPPING[card.access]}
                        id={card.id}
                        key={card.id}
                        handleRemove={handleRemove}
                        type={"reject"}
                        namespace={card.resource.pattern}
                      />
                    ))
                }
                <Box display="flex" alignItems="center" marginLeft={3} zIndex={"1"}>
                  <Fab color="black" aria-label="add" style={{ marginLeft: "0" }} onClick={handleAddNamespaceRejectCard}>
                    <AddIcon />
                  </Fab>
                </Box>
              </Box>
            </>
          )
        }

        {
          (
            <>
              <Box display="flex" alignItems="center" marginTop={3}>
                <KeyRounded />
                <Typography variant="h2" component="div" marginLeft={1} fontWeight="bold" marginTop={0} >
                  Config
                </Typography>
              </Box>
              <Box style={containerStyle}>
                {
                  configRejectPolicies.length > 0 && configRejectPolicies.map(card =>
                  (
                    <ResourceCard
                      handlePolicyUpdate={handlePolicyUpdate}
                      access={ACCESS_MAPPING[card.access]}
                      getKeys={props.getKeys}
                      resource={card.resource}
                      getNamespaces={props.getNamespaces}
                      resourceName={card.resource.name}
                      pattern={card.resource.pattern}
                      handleRemove={handleRemove}
                      type={"reject"}
                      key={card.id}
                      id={card.id}
                    />
                  ))
                }
                <Box display="flex" alignItems="center" marginLeft={3} zIndex={"1"}>
                  <Fab color="black" aria-label="add" style={{ marginLeft: "0" }} onClick={handleAddConfigRejectCard}>
                    <AddIcon />
                  </Fab>
                </Box>
              </Box>
            </>
          )
        }

        <Button
          variant="outlined"
          btnColor="coal"
          size="large"
          style={buttonStyle}
          onClick={handleSubmitPolicies}
        >
          Submit
        </Button>

      </Box>
        )
      }
      



    </AccessControlContainer>
  );
};

const buttonStyle = {
  display: 'block',
  margin: '20px auto 100px auto', // Center horizontally
  padding: '10px 20px',
  fontSize: '16px',
};

const AccessControlContainer = styled.section`
  height: calc(100vh - 220px);
  .inner-container {
    flex-direction: ${isMobile() ? "column" : "row"};
    margin-bottom: ${isMobile() ? "40px" : "20px"};
    .actionBar {
      flex-direction: ${isMobile() ? "column" : "row"};
      align-items: ${isMobile() ? "flex-start" : "flex-start"};
      margin-left: ${isMobile() ? "unset" : "auto"};
      margin-top: ${isMobile() ? "10px" : "unset"};
    }
  }
`;

const containerStyle = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-start", // Align items from left to right
  alignItems: "center",
  gap: '2rem', // Space between the components
  padding: '10px',
  width: '100%',
  maxWidth: '100%',
  marginLeft: '25px',
};

const itemStyle = {
  flex: '1 1 calc(50% - 20px)', // Adjust width for two components per row with gap
  boxSizing: 'border-box',
  minWidth: '300px', // Minimum width to ensure proper layout
};

const mapStateToProps = (state) => {
  console.log("state: ", state);
  const { FeatureConfig } = state;
  return {
    userData: FeatureConfig.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getNamespaces: bindActionCreators(
      FeatureConfigActions.getNamespaces,
      dispatch
    ),
    getKeys: bindActionCreators(FeatureConfigActions.getKeys, dispatch),
    getUser: bindActionCreators(
      FeatureConfigActions.getUser,
      dispatch
    ),
    upsertUser: bindActionCreators(
      FeatureConfigActions.upsertUser,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setUserData: bindActionCreators(
      FeatureConfigActions.setUserData,
      dispatch
    ),
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigAccessControl);
